import { render, staticRenderFns } from "./linkageOptCom.vue?vue&type=template&id=9144f272&scoped=true&"
import script from "./linkageOptCom.vue?vue&type=script&lang=js&"
export * from "./linkageOptCom.vue?vue&type=script&lang=js&"
import style0 from "./linkageOptCom.vue?vue&type=style&index=0&id=9144f272&prod&lang=css&"
import style1 from "./linkageOptCom.vue?vue&type=style&index=1&id=9144f272&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9144f272",
  null
  
)

export default component.exports